import React from 'react'

// Styles
import './styles.scss'

// Icons
import IconLoading from './images/iconLoading'

export default () => {
  return (
    <div className={'loading-page'}>
      <IconLoading />
    </div>
  )
}
